import React, { useState } from 'react';
import { Layout } from 'antd';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Sidebar from './Sidebar/Sidebar';
import Header from './Header';
import Dashboard from '../Dashboard/Dashboard';
import { UsersList, UserUpsertPage, UserViewPage, ChangePasswordPage, UserProfile } from '../../pages/Users/routes';
import { ClientsList, ClientUpsertPage, ClientViewPage, ClientUpdatePatientPage, ClientUpdateSpecialistPage } from '../../pages/Clients/routes';
import { MembershipTypeUpsertPage, MembershipTypesList, MembershipTypeViewPage } from '../../pages/MembershipTypes/routes';
import { SpecialtiesList, SpecialtyUpsertPage } from '../../pages/Specialties/routes';
import { ClientReportPage, PlanReportPage } from '../../pages/Reports/routes';
import GlobalLoading from '../Utility/GlobalLoading';
import SplashPage from '../../pages/Splash/SplashPage';
import './Sidebar/Sidebar.css';
import CarouselPage from '../../pages/Carousel/CarouselPage';
import SpecialistReportPage from '../../pages/Reports/Specialist/SpecialistList';
import PatientListReportPage from '../../pages/Reports/Patients/PatientListReport';

const Admin = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { loading } = useAuth();

  if (loading) return <GlobalLoading />;

  const contentClassNames = collapsed
    ? 'sidebar--collapsed absolute t-0 r-0 sidebar'
    : 'sidebar absolute t-0 r-0 ';

  return (
    <Layout>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className={contentClassNames}>
        <Header />
        <main
          className="w-full"
          style={{
            backgroundColor: '#E5E5E5',
            minHeight: 'calc(100vh - 56px)',
          }}
        >
          <Routes>
            {/* Ruta por defecto: Dashboard */}
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Rutas de Usuarios */}
            <Route path="/users/all" element={<UsersList />} />
            <Route path="/users/add" element={<UserUpsertPage />} />
            <Route path="/users/:id/edit" element={<UserUpsertPage />} />
            <Route path="/users/view/:id" element={<UserViewPage />} />
            <Route path="/users/profile" element={<UserProfile />} />
            <Route path="/users/:id/change-password" element={<ChangePasswordPage />} />

            {/* Rutas de Clientes */}
            <Route path="/clients/all" element={<ClientsList />} />
            <Route path="/clients/add" element={<ClientUpsertPage />} />
            <Route path="/clients/:id/edit" element={<ClientUpsertPage />} />
            <Route path="/clients/view/:id" element={<ClientViewPage />} />
            <Route path="/clients/patient/:id/edit" element={<ClientUpdatePatientPage />} />
            <Route path="/clients/specialist/:id/edit" element={<ClientUpdateSpecialistPage />} />


            {/* Rutas de Splash */}
            <Route path="/splash" element={<SplashPage />} />

            {/* Rutas de Carousel */}
            <Route path="/carousel" element={<CarouselPage />} />

            {/* Rutas de Catálogos tipo de membresia*/}
            <Route path="/memberships/all" element={<MembershipTypesList />} />
            <Route path="/memberships/add" element={<MembershipTypeUpsertPage />} />
            <Route path="/memberships/:id/edit" element={<MembershipTypeUpsertPage />} />
            <Route path="/memberships/view/:id" element={<MembershipTypeViewPage />} />

            {/* Rutas de Especialidades */}
            <Route path="/specialties/all" element={<SpecialtiesList />} />
            <Route path="/specialties/add" element={<SpecialtyUpsertPage />} />
            <Route path="/specialties/:id/edit" element={<SpecialtyUpsertPage />} />

            {/* Reportes */}
            {/* <Route path="/reports/clients" element={<ClientReportPage />} />
            <Route path="/reports/plans" element={<PlanReportPage />} /> */}
            <Route path="/reports/specialists" element={<SpecialistReportPage />} />
            <Route path="/reports/patients" element={<PatientListReportPage />} />


            {/* Ruta catch-all: redirige al dashboard si la ruta no existe */}
            <Route path="*" element={<Dashboard />} />
          </Routes>
        </main>
      </div>
    </Layout>
  );
};

export default Admin;
